import { render, staticRenderFns } from "./cdn-logo-he.vue?vue&type=template&id=1ffbfeee&"
import script from "./cdn-logo-he.vue?vue&type=script&lang=js&"
export * from "./cdn-logo-he.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports